export const authKeys = {
  providers: () => ['auth', 'providers'] as const,
  twoFactor: () => ['auth', 'two-factor'] as const,
};
